__turbopack_context__.v({
  "chart": "q-nwwa_chart",
  "chart-wrapper": "q-nwwa_chart-wrapper",
  "colored-box": "q-nwwa_colored-box",
  "first": "q-nwwa_first",
  "label-value": "q-nwwa_label-value",
  "last": "q-nwwa_last",
  "line": "q-nwwa_line",
  "mobile": "q-nwwa_mobile",
  "tooltip": "q-nwwa_tooltip",
  "tooltip-container": "q-nwwa_tooltip-container",
  "tooltip-content-wrapper": "q-nwwa_tooltip-content-wrapper",
  "tooltip-description": "q-nwwa_tooltip-description",
});
